import './FpTabHead.less'

export default class FpTabHead {
  /**
   * constructor
   * @param {object} options - Options of the tab head
   */
  constructor (options) {
    if (!window.Forepaas.config.server) return this
  }
}
